export default __webpack_public_path__ + "static/media/sports (3).5b7ec5e1.jpg";